<!--
NFC > map screen
@author bmk11u
-->
<template>
  <div>
    <Logo />
    <GMapMap
      :center='{lat:55.872446, lng:-4.289041}'
      :zoom='15'
      class='mapCanvas'
      ref='mapRef'
      :options='{
        styles: getStyles(),
        fullscreenControl: false,
        mapTypeControl: true,
        mapTypeControlOptions: {
          position: google && google.maps.ControlPosition.TOP_LEFT,
          style: google && google.maps.MapTypeControlStyle.DROPDOWN_MENU
        },
        streetViewControl: true,
        zoomControl: true
      }'>
    </GMapMap>
    <MapToolbar ref="mapToolbar" :level="floor"
      @levelChanged="onLevelChanged"
      @showAccessibleRoutesChanged="onShowAccessibleRoutesChanged"
      useAccessibleRoutesEnbled="false" />
    <div class="list-group p-2">
      <router-link
        class="list-group-item list-group-item-action list-group-item-primary"
        :to="'goingtobuilding?x=' + x + '&y=' + y">
        Get Directions
      </router-link>
      <a href="JavaScript:void(0)" class="list-group-item list-group-item-action list-group-item-primary"
        data-toggle="modal" data-target="#feedbackModal" v-if="authenticated">
        Feedback
      </a>
    </div>
    <FeedbackForm v-if="authenticated" :info="feedbackInfo" />
    <div id="pusher"></div>
    <Footer active="notifications" v-if="authenticated"/>
  </div>
</template>

<script>
import Logo from '@/components/Logo.vue'
import MapToolbar from '@/components/MapToolbar.vue'
import FeedbackForm from '@/components/FeedbackForm.vue'
import MapCommon from '@/mixins/MapCommon.js'
import LocationsCommon from '@/mixins/LocationsCommon.js'
import Footer from '@/components/FooterMenu.vue'

export default {
  name: 'YouAreHere',
  components: {
    Logo,
    MapToolbar,
    FeedbackForm,
    Footer
  },
  mixins: [
    MapCommon,
    LocationsCommon
  ],
  data () {
    return {
      google: null, /* to hold gmap api from promise */
      authenticated: this.$cookies.get('authenticated'),
      src: this.$route.query.src,
      x: this.$route.query.x,
      y: this.$route.query.y,
      feedbackInfo: {}
    }
  },
  mounted () {
    // we need to get gmapApi...
    this.$refs.mapRef.$gmapApiPromiseLazy().then((gmapApi) => {
      console.log('gmapApi promise fulfilled')
      this.google = gmapApi
    }).then(() => {
    // Wait for Google Maps to load
      this.$refs.mapRef.$mapPromise.then((map) => {
        // Add marker and initialise overlays
        this.map = map
        let location = {}
        location.floor = 1
        this.addMarker(map, 'You are here', this.$route.query.x, this.$route.query.y, null, true, true, require('../../assets/location.png'))
        this.initOverlays(map, location)
        this.feedbackInfo.src = this.src
        this.feedbackInfo.geoLatitude = this.x
        this.feedbackInfo.geoLongitude = this.y
      })
    })
  }
}
</script>
